export default "__VITE_ASSET__9EtVYgTz__"